module.exports = __webpack_public_path__ + "static/media/ntt.1ba557d0.mp3";